module.exports = __webpack_public_path__ + "static/media/woman_04.8094049b.png";